import React from 'react';

/* Translations */
import { useTranslation } from 'react-i18next';

/* Components */
import RendererIf from 'components/RendererIf';
import NoPermissions from './NoPermissions';

/* Styled Components */
import {
  PermissionItem,
  PermissionTitle,
  PermissionText,
} from '../styles/MemberConfig';

/* Constants, Hooks, Services */
import usePermission from 'hooks/usePermission';

interface PermissionsNoToggleProps {
  memberType: string;
  memberPermissions: any[];
  checkPermission: any;
}

const PermissionsNoToggle: React.FC<PermissionsNoToggleProps> = ({
  memberType,
  memberPermissions,
  checkPermission,
}) => {
  const { t } = useTranslation();
  const { permissionsList } = usePermission();

  return (
    <RendererIf
      condition={memberPermissions.length !== 0}
      alternative={<NoPermissions memberType={memberType} />}
    >
      {permissionsList.map((item: any, index: number) => {
        const { id, name } = item;
        if (checkPermission(id)) {
          return (
            <PermissionItem key={index}>
              <PermissionTitle>
                {t(
                  'settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.PERMISSIONS.PERMISSION',
                )}{' '}
                {index + 1}
              </PermissionTitle>
              <PermissionText>{name}</PermissionText>
            </PermissionItem>
          );
        }
        return null;
      })}
    </RendererIf>
  );
};

export default PermissionsNoToggle;
